<template>
  <v-dialog v-if="corporate" scrollable :value="value" @input="close()" width="800px">
    <v-card>
      <v-card-title class="grey lighten-4 py-4 title black--text">
        Employee {{ employee ? `| ${employee.email}` : '' }}
      </v-card-title>
      <v-card-text>
        <v-form v-model="Form.valid" @submit.prevent="">
          <v-container grid-list-xs :class="$vuetify.breakpoint.mdAndUp ? 'pa-5' : ''">
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  type="text"
                  label="Email"
                  v-validate="'email|required'"
                  :error-messages="errors.collect('email')"
                  data-vv-name="email"
                  v-model="Form.email"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="corporate.category1_title">
                <v-autocomplete
                  v-model="Form.choice1_id"
                  v-validate="'required'"
                  :error-messages="errors.collect('category1')"
                  data-vv-name="category1"
                  :items="categoryChoices['1']"
                  item-text="name"
                  item-value="id"
                  attach
                  :label="corporate.category1_title || 'Category Title 1'"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 v-if="corporate.category2_title">
                <v-autocomplete
                  v-model="Form.choice2_id"
                  v-validate="'required'"
                  :error-messages="errors.collect('category2')"
                  data-vv-name="category2"
                  :items="categoryChoices['2']"
                  item-text="name"
                  item-value="id"
                  attach
                  :label="corporate.category2_title || 'Category Title 2'"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 v-if="corporate.category3_title">
                <v-autocomplete
                  v-model="Form.choice3_id"
                  v-validate="'required'"
                  :error-messages="errors.collect('category3')"
                  data-vv-name="category3"
                  :items="categoryChoices['3']"
                  item-text="name"
                  item-value="id"
                  attach
                  :label="corporate.category3_title || 'Category Title 3'"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 v-if="corporate.category4_title">
                <v-autocomplete
                  v-model="Form.choice4_id"
                  v-validate="'required'"
                  :error-messages="errors.collect('category4')"
                  data-vv-name="category4"
                  :items="categoryChoices['4']"
                  item-text="name"
                  item-value="id"
                  attach
                  :label="corporate.category4_title || 'Category Title 4'"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <div class="d-flex align-center">
                  <v-switch v-model="Form.is_use_employee_quota_config"></v-switch>
                  <span class="subtitle-1">Use Employee Level Quota Configuration</span>
                </div>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  type="number"
                  label="Quota per head (minutes)"
                  placeholder="Leave empty for unlimited quota"
                  :error-messages="errors.collect('quota_per_head')"
                  data-vv-name="quota_per_head"
                  v-model="Form.quota_per_head"
                  :disabled="!Form.is_use_employee_quota_config"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  label="Refresh Quota"
                  :items="refreshQuotaOptions"
                  :error-messages="errors.collect('refresh_quota')"
                  data-vv-name="refresh_quota"
                  v-model="Form.refresh_quota"
                  :disabled="!Form.is_use_employee_quota_config"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="pb-3 pr-5">
        <v-spacer></v-spacer>
        <v-btn text @click="close">Cancel</v-btn>
        <v-btn color="primary" text :disabled="!Form.valid" @click="edit">{{ employee ? 'save' : 'add' }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Form from '../form/form';
import formMixin from '../Mixins/form';
import corporateService from '../services/corporate';
import numberUtil from '../utils/number';

export default {
  mixins: [formMixin],
  props: {
    value: Boolean,
    transaction: Object,
    corporate: Object,
    employee: { type: Object, default: null },
    categoryChoices: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      Form: new Form({
        data() {
          return {
            email: '',
            choice1_id: null,
            choice2_id: null,
            choice3_id: null,
            choice4_id: null,
            is_use_employee_quota_config: true,
            quota_per_head: null,
            refresh_quota: null,
            valid: false,
          };
        },
      }),
      refreshQuotaOptions: [
        { text: 'No Refresh', value: null },
        { text: 'Daily', value: 'daily' },
        { text: 'Weekly', value: 'weekly' },
        { text: 'Monthly', value: 'monthly' },
        { text: 'Yearly', value: 'yearly' },
      ],
    };
  },
  computed: {
    numberUtil() {
      return numberUtil;
    },
    category1Option() {
      return null;
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.setUpData();
      }
    },
  },
  methods: {
    setUpData() {
      if (this.employee) {
        this.Form.email = this.employee.email;
        this.Form.choice1_id = this.employee.category1 ? this.employee.category1.id : null;
        this.Form.choice2_id = this.employee.category2 ? this.employee.category2.id : null;
        this.Form.choice3_id = this.employee.category3 ? this.employee.category3.id : null;
        this.Form.choice4_id = this.employee.category4 ? this.employee.category4.id : null;
        this.Form.is_use_employee_quota_config = this.employee.is_use_employee_quota_config;
        this.Form.quota_per_head = this.employee.quota_per_head;
        this.Form.refresh_quota = this.employee.refresh_quota;
      }
    },
    edit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$root
            .$confirm(`${this.employee ? 'Edit' : 'Add'} `, `Are you confirm to ${this.employee ? 'edit' : 'add'} ?`, {
              color: 'primary',
            })
            .then((confirm) => {
              if (confirm) {
                corporateService
                  .editOrAddEmployee(this.corporate.id, this.employee ? this.employee.id : null, this.Form)
                  .then(() => {
                    this.$notify({
                      title: 'Success',
                      text: `Successfully ${this.employee ? 'edit' : 'add'} employee.`,
                      type: 'success',
                    });
                    this.close();
                    this.$emit('success');
                  });
              }
            });
        }
      });
    },
    close() {
      this.resetFormError(null, this.Form);
      this.$emit('input', false);
    },
  },
  mounted() {
    this.setUpData();
  },
  components: {},
};
</script>
